import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import { alertsResponse, type UseAlerts } from './Alerts.schema';

export const alertsKeys = {
	all: ['alerts'] as const,
	list: (days: number, limit: number) => ['alerts', days, limit] as const,
};

export const useAlerts = (days = 1, limit = 20, opts: UseAlerts['opts'] = {}) =>
	useQuery<UseAlerts['response']>({
		...opts,
		queryKey: alertsKeys.list(days, limit),
		queryFn: () => API.get('/alerts', { params: { days, limit } }).then((res) => alertsResponse.parse(res.data)),
		refetchInterval: 60_000,
	});
